import { Box, SimpleGrid, Skeleton, VStack } from '@chakra-ui/react';

const AgentsSkeleton = () => {
  return (
    <Box>
      <SimpleGrid columns={{ base: 2, sm: 2, md: 3, lg: 3 }} gap={4} mb={10}>
        {Array.from({ length: 3 }).map((_, index) => (
          <Box
            key={index}
            borderRadius={12}
            bg="white"
            p={4}
            boxShadow="0 0 1px 0 rgba(24, 24, 27, 0.30), 0 4px 8px 0 rgba(24, 24, 27, 0.10)"
          >
            <VStack align="stretch" gap={3}>
              <Skeleton height="20px" width="50%" borderRadius="md" />
              <Skeleton height="20px" width="100%" borderRadius="md" />
              <Skeleton height="20px" width="65%" borderRadius="md" />
            </VStack>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default AgentsSkeleton;
